import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BehfaRole_Interface, Empty_BehfaRole_Interface } from 'src/app/Interface/BehfaRole_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { BehfaRoleService } from 'src/app/Service/BehfaRole/BehfaRole.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-BehfaRoleListAdmin',
  templateUrl: './BehfaRoleListAdmin.component.html',
  styleUrls: ['./BehfaRoleListAdmin.component.scss']
})
export class BehfaRoleListAdminComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private BehfaRole_Service:BehfaRoleService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_BehfaRole:Array<BehfaRole_Interface>=[]
  Data_Seleted_Delete:BehfaRole_Interface=Empty_BehfaRole_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1105).subscribe(
      data=>{
        this.ReadData_BehfaRole()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_BehfaRole(){
    this.Procssing=true
    this.BehfaRole_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_BehfaRole=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:BehfaRole_Interface){
    item.deletingProccess=true
    this.modalRef_Delete.hide()
    this.BehfaRole_Service.DeleteBehfaRole(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully")
        this.ReadData_BehfaRole()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Priority(item:BehfaRole_Interface){
    item.deletingProccess=true
    this.BehfaRole_Service.PriorityBehfaRole(item.id,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("The information was registered successfully")
          
        this.ReadData_BehfaRole()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
